import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'

// state
export const state = {
  items: [],
  total: 0,
  filtersData: {
    vendorsList: []
  },
  pdf: undefined
}

// getters
export const getters = {
  items: state => state.items,
  total: state => state.total,
  filtersData: state => state.filtersData,
  pdf: state => state.pdf
}

// mutations
export const mutations = {

  ITEMS_DATA (state, data) {
    state.items = data
  },

  TOTAL (state, data) {
    state.total = data
  },

  PDF (state, data) {
    state.pdf = data
  }
}

// actions
export const actions = {

  async fetchAll ({ commit }, filterData) {
    const { data } = await axios.get(laroute.route('received_purchase_orders', { companyAbbr: store.getters['auth/company'], ...filterData }))
    commit('ITEMS_DATA', data.items)
    commit('TOTAL', data.total)
  },

  async generatePDF ({ commit }, { filterData }) {
    const { data } = await axios.get(laroute.route('received_po_pdf', { companyAbbr: store.getters['auth/company'], ...filterData }), { responseType: 'arraybuffer' })
    commit('PDF', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/receivedPurchaseOrdersByPN.js